module.exports = __webpack_public_path__ + "img/amerex.a9e24374.png";